export const POLICY_ISOLATIONISM_MELEE_BONUS = 1;

export const POLICY_ISOLATIONISM_SPECIAL_BUILDING_DISCOUNT = 1;


